module.exports = __webpack_public_path__ + "static/media/gpsea.4f7a42d6.jpg";